type TUTMParams = Record<string, string>;

const LS_UTM_PARAMS = 'utmParams';

export const setUTMTagsToLocalStorage = () => {
  let shouldSetUTMTags = false;
  const url = new URL(window.location.href);
  const urlParams = new URLSearchParams(url.search);

  const utmParams: TUTMParams = {};

  for (const [utmTag, value] of urlParams.entries()) {
    if (utmTag.includes('utm_')) {
      shouldSetUTMTags = true;

      utmParams[utmTag] = value;
    }
  }

  if (shouldSetUTMTags) {
    window.localStorage.setItem(LS_UTM_PARAMS, JSON.stringify(utmParams));
  }
};
